import request from 'superagent';

export function messageOwner(data, fullLocale) {
    return request
        .post(
            `/bizops/travelerHome/messageOwnerWithAttachment?locale=${fullLocale}`
        )
        .set('X-HomeAway-Restfully', true)
        .send(data);
}
